import gql from 'graphql-tag';

export const SimulationAreaResultsPartial = gql`
  subscription simulationAreaResultsPartial(
    $jobId: String!
    $uuid: String!
    $timeResolutionHrs: Int
  ) {
    simulationAreaResultsPartial(
      jobId: $jobId
      areaUUID: $uuid
      timeResolutionHrs: $timeResolutionHrs
    ) {
      areaUuid
      cumulativeBills
      cumulativeGridTrades
      currentMarket
      cumulativeNetEnergyFlow
      deviceStatistics
      energyTradeProfileAreaThroughput
      kpi
      marketSummary {
        externalTradedVolume
        averageEnergyRate
        timestamp
        tradedVolume
      }
      priceEnergyAreaBalance
      priceEnergyDay
      latestSavingsKpi(duration: DAILY)
      savingsKpiProfile(duration: DAILY)
      assetsInfo
      progressInfo {
        percentageCompleted
        etaSeconds
        elapsedTimeSeconds
      }
      status
    }
  }
`;
